;(() => {
    class StoresService {
        constructor(
            APIService,
            $q,
            ErrorService
        ) {
            this.apiService = APIService;
            this.$q = $q;
            this.errorService = ErrorService;
            this.subscriptions = [];
        }

        /**
         * Checks the store subscriptions and returns true if the subscription exists
         * @param storeId {number}
         * @param subscription {string}
         * @returns {promise}
         */
        checkStoreSubscription(
            storeId,
            subscription
        ) {
            return this.apiService.Stores.getStoreSubscriptions(storeId).then(
                function (results) {
                    const foundSubscription = results.data
                        .find((element) => element.Name === subscription);
                    return !!foundSubscription;
                },
                function error(results) {
                    ErrorService.showError("An unexpected error has occurred", results);
                }
            );
        }

        /**
         * Get a subscription by name
         * @param subscriptionName {string}
         */
        getSubscriptionByName(subscriptionName) {
            const deferred = this.$q.defer();
            let subscription = this.subscriptions.find((element) => element.Name === subscriptionName)
            if (!subscription) {
                return this.apiService.Stores.getSubscriptionByName(subscriptionName).then(
                    (results) => {
                        subscription = new Dashboard.Models.Subscription();
                        subscription = subscription.initialiseSubscription(results.data);
                        this.subscriptions.push(subscription);
                        return subscription;
                    }
                );
            } else {
                deferred.resolve(subscription);
            }
            return deferred.promise;
        }

        /**
         * Get a subscription by name
         * @param subscriptionId {number}
         */
        getSubscriptionById(subscriptionId) {
            const deferred = this.$q.defer();
            let subscription = this.subscriptions.find((element) => element.Id === subscriptionId)
            if (!subscription) {
                return this.apiService.Stores.getSubscriptionById(subscriptionId).then(
                    (results) => {
                        subscription = new Dashboard.Models.Subscription();
                        subscription = subscription.initialiseSubscription(results.data);
                        this.subscriptions.push(subscription);
                        return subscription;
                    }
                );
            } else {
                deferred.resolve(subscription);
            }
            return deferred.promise;
        }

        /**
         * Subscribe a store to the subscription
         * @param subscriptionId {number}
         * @param storeId {number}
         * @returns {promise}
         */
        subscribeStore(
            subscriptionId,
            storeId
        ) {
            return this.apiService.Stores.subscribeStore(subscriptionId, storeId);
        }

        /**
         * Gets all stores for a brand or only live stores and those flagged to be included
         * @param brandId {number}
         * @param includeTestStores
         * @param includeUnavailableStores
         * @returns {promise}
         */
        getStoresForBrand(
            brandId,
            includeTestStores,
            includeUnavailableStores
        ) {
            return this.apiService.Stores.getStoresForBrand(
                brandId,
                includeTestStores,
                includeUnavailableStores
            );
        };

        /**
         * Gets the stores for a call center id
         * @param callCenterId {number}
         * @returns {promise}
         */
        getStoresForCallCenter(callCenterId) {
            return this.apiService.Stores.getStoresForCallCenter(callCenterId);
        }

        getStoresByStoreIds(storeIds) {
            return this.apiService.Stores.getStoresByStoreIds(storeIds);
        }

        getStoreById(storeId) {
            return this.apiService.Stores.getStoreById(storeId);
        }

        toggleAllowOnlineOrders(
            storeId,
            allowOnlineOrders
        ) {
            return this.apiService.Stores.toggleAllowOnlineOrders(storeId, allowOnlineOrders);
        }

        toggleOrderCompleteNotifications(
            storeId,
            enabled
        ) {
            return this.apiService.Stores.toggleOrderCompleteNotifications(storeId, enabled);
        }

        updateKerbsideCollectMobileNumber(
            storeId,
            mobileNumber
        ) {
            return this.apiService.Stores.updateKerbsideCollectMobileNumber(storeId, mobileNumber)
        }
    }

    angular.module("dashboard")
        .service(
            "StoresService",
            [
                "APIService",
                "$q",
                "ErrorService",
                StoresService
            ]
        );

})();
